module.exports = __webpack_public_path__ + "assets/img/202109-4W.7850b47e.png";